module.exports = __webpack_public_path__ + "img/edge_endo_logo_icon.81175a9a.png";